import { useEffect, useState, useRef, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StateButton from "../../components/state-button/StateButton";
import "./ProductPage.scss";
import BannerImg from "../../assets/images/updated_Product-BannerImg-new.png";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FeaturesImg from "../../assets/images/FeaturesImg-new.png";
import iPhoneimg from "../../assets/images/updated_iPhone-15-Pro.png";
import {NotificationManager} from 'react-notifications';
import ContactForm from "../../components/ContactForm/ContactForm";

import { getServicesByProductId, getMailProductCountry, getMailProductCity, getMailProductCitiesByCountry, submitInquiry } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

import { useTranslation } from "react-i18next";

const ProductPage = () => {
  Tag("Geschäftsadresse")
  const { t } = useTranslation(["common","business-address"]);


  const {hostLanguage} = useLangContext();

  const [cities,setCities] = useState([]);
  const [countries,setCountries] = useState([]);
  const [services,setServices] = useState([]);

  const contactRef = useRef(null);
  const [selectedCities,setSelectedCities] = useState([]);
  
  // fetch all mail product cities
  const fetchMailProductCity = async(product_id) => {
    try
    {
      let apiRes = await getMailProductCity(product_id);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setCities(Object.values(responseData.data).flat());
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  // fetch all mail product countries
  const fetchMailProductCountry = useCallback( async(product_id) => {
    try
    {
      let apiRes = await getMailProductCountry(product_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setCountries(Object.values(responseData.data).flat());
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }, [hostLanguage]);
  // fetch all mail product services
  const fetchProductServices = useCallback( async (product_id) => {
    try
    {
      let apiRes = await getServicesByProductId(product_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setServices(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  },[hostLanguage]);

  const sendInquiry = async (values, { resetForm }) => {
    try {
      let data_values = {
        companyname: values.companyname,
        name: values.name,
        email: values.email,
        phonenumber: values.phonenumber,
        message: values.message,
      };

      let apiRes = await submitInquiry(data_values);
      let responseData = await apiRes.json();
      if (responseData.res) {
        resetForm({ values: "" });
        NotificationManager.success(responseData.msg, "", 2000);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  
  //Get All Mail Product City
  const handleSelectedCities = async(country_id) => {
    try
    {
      let apiRes = await getMailProductCitiesByCountry(country_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setSelectedCities(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }

  const handleTabSelect = (key) => {
    const selectedCountryId = countries.find((item) => item?.country?.name === key);
    handleSelectedCities(selectedCountryId?.country?.id);
  }

  useEffect(()=>{
    fetchMailProductCity(1);
    fetchMailProductCountry(1);
    fetchProductServices(1);
  },[hostLanguage, fetchMailProductCountry, fetchProductServices])

  return (
    <>
      <div id="ProductMailbox" className="MainbBody">
        <div className="InnerBannerScetion">
          <div className="InnerBannerScetionLft">
            <div>
              <h5>{t('business-address:banner.title')}</h5>
              <ul>
                <li>{t('business-address:banner.list_0')}</li>
                <li>{t('business-address:banner.list_1')}</li>
                <li>{t('business-address:banner.list_2')}</li>
                <li>{t('business-address:banner.list_3')}</li>
                <li>{t('business-address:banner.list_4')}</li>
              </ul>
            </div>
            <div className="BtnGrp">
              <Link className="BtnGrpLoc" to ='/standorte'>{t('business-address:banner.button_0')}</Link>
              <StateButton 
                className="BtnGrpBN" text={t('business-address:banner.button_1')}
                to={"/preise/geschaeftsadresse"}
                userTo='/LetStarted'
              />
              </div>
          </div>

          <div className="InnerBannerScetionRgt">
            <Image
              src={BannerImg}
              className="BannerImg"
              alt="BannerImg"
              fluid
            />
          </div>
        </div>
        <div className="FourBoxScetion">
          <Container>
            <Row>
              <Col sm={6} md={3}>
                <div className="FourBoxScetionBox">
                  <span>
                    {" "}
                      <Image
                        src={"/images/virtueller-arbeitsplatz.svg"}
                        className="BannerImg"
                        alt="BannerImg"
                        fluid
                      />
                  </span>
                    <h3>{t('business-address:boxes.box_0.title')}</h3>
                    <p>{t('business-address:boxes.box_0.description')}</p>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="FourBoxScetionBox">
                  <span>
                    {" "}
                      <Image
                        src={"/images/briefe-und-pakete.svg"}
                        className="BannerImg"
                        alt="BannerImg"
                        fluid
                      />
                  </span>
                    <h3>{t('business-address:boxes.box_1.title')}</h3>
                    <p>{t('business-address:boxes.box_1.description')}</p>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="FourBoxScetionBox">
                  <span>
                    {" "}
                      <Image
                        src={"/images/digitale-briefe.svg"}
                        className="BannerImg"
                        alt="BannerImg"
                        fluid
                      />
                  </span>
                    <h3>{t('business-address:boxes.box_2.title')}</h3>
                    <p>{t('business-address:boxes.box_2.description')}</p>
                </div>
              </Col>
              <Col sm={6} md={3}>
                <div className="FourBoxScetionBox">
                  <span>
                    {" "}
                      <Image
                        src={"/images/weltweiter-versand.svg"}
                        className="BannerImg"
                        alt="BannerImg"
                        fluid
                      />
                  </span>
                    <h3>{t('business-address:boxes.box_3.title')}</h3>
                    <p>{t('business-address:boxes.box_3.description')}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="LocationsScetion">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t('business-address:locations.title')}</h2>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col sm={12}>
                <Tabs
                  defaultActiveKey="all"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                  onSelect={handleTabSelect}
                >
                  <Tab eventKey="all" title={t('business-address:locations.button_all') ?? "TAB"}>
                    <div className="LocationName">
                      <ul>
                        {cities?.map((item,index)=>{
                            return(
                              <li key={index}>
                                <div className="LocationNameBox">
                                  <Link to={'/geschaeftsadresse/'+item?.city?.key}>
                                    <h4>{item?.city?.name?.toUpperCase()}</h4>
                                  </Link>
                                </div>
                              </li>
                            )
                          })}
                      </ul>
                    </div>
                  </Tab>
                  
                  {countries?.map((item, index) => (
                    <Tab
                      key={item?.country?.id}
                      eventKey={item?.country?.name}
                      title={item?.country?.name}
                    >
                      <div className="LocationName">
                        <ul>
                          {selectedCities?.map((city_item, city_index) => {
                            return(
                              <li key={city_index}>
                                <div className="LocationNameBox">
                                    <Link to={'/geschaeftsadresse/'+city_item?.city?.key}>
                                    <h4>{city_item?.city?.name?.toUpperCase()}</h4>
                                  </Link>
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="FeaturesScetion">
          <Container fluid>
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t('business-address:features.title')}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} lg={6}>
                <div className="FeaturesScetionLft">
                  <Image
                    src={FeaturesImg}
                    className="FeaturesImg w-100"
                    alt="FeaturesImg"
                  />
                </div>
              </Col>

              <Col sm={12} lg={6}>
                <div className="FeaturesScetionRgt">
                  <ul>
                    <li>
                      <h4><span>1</span> {t('business-address:features.list_0.title')}</h4>
                      {t('business-address:features.list_0.description')}
                    </li>
                    <li>
                      <h4><span>2</span> {t('business-address:features.list_1.title')}</h4>
                      {t('business-address:features.list_1.description')}
                    </li>
                    <li>
                      <h4><span>3</span> {t('business-address:features.list_2.title')}</h4>
                      {t('business-address:features.list_2.description')}
                    </li>
                    <li>
                      <h4><span>4</span> {t('business-address:features.list_3.title')}</h4>
                      {t('business-address:features.list_3.description')}
                    </li>
                    <li>
                      <h4><span>5</span> {t('business-address:features.list_4.title')}</h4>
                      {t('business-address:features.list_4.description')}
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="AppScetion">
          <Container>
            <Row className="align-items-center">
              <Col sm={6}>
                <Image
                  src={iPhoneimg}
                  className="laptopbig"
                  alt="LaptopBig"
                  fluid
                />
              </Col>
              <Col sm={6}>
                <div className="AppScetionTxt">
                  <div>
                    <h4>{t('business-address:app.title')}</h4>
                    <h5>{t('business-address:app.description')}</h5>
                  </div>
                  <div className="ImgGrp">
                    <span className="ImgGrpImg">
                      <Link to={"https://play.google.com/store/apps/details?id=com.cleverdomizilmail"}>
                        <Image
                          src={"/images/cleverdomizil-google-play-virtuelles-buero-app.svg"}
                          alt={t("business-address:app.image_alt_google")}
                        />
                      </Link>
                    </span>
                    <span className="ImgGrpImg">
                      <Link to={"https://apps.apple.com/in/app/cleverdomicile/id6502281781"}>
                        <Image
                          src={"/images/cleverdomizil-appstore-virtuelles-buero-app.svg"}
                          alt={t("business-address:app.image_alt_apple")}
                        />
                      </Link>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="PlanScetion">
          <Container className="">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t('business-address:inbox.title')}</h2>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col sm={12}>
                <div className="PlanComparisonDiv">
                  <table>
                    <tbody>
                      <tr>
                        <th>&nbsp;</th>
                        <th>
                          <h3>{t('business-address:inbox.tariff_private')}</h3>
                        </th>
                        <th>
                          <h3>{t('business-address:inbox.tariff_company')}</h3>
                        </th>
                      </tr>
                      {services?.map((item,index)=>{
                        return(
                          <tr key={index}>
                            <td>{item?.service_name}</td>
                            <td>
                              {item?.private_status === 1 && (
                                <Image
                                  src={"/images/feature-included.svg"}
                                  className="TickImg"
                                  alt="TickImg"
                                />
                              )}
                                <br />
                                {item?.additional_private_status!= null ? item?.additional_private_status: ''}
                            </td>

                            <td>
                              {item?.business_status === 1 && (
                                <Image
                                  src={"/images/feature-included.svg"}
                                  className="TickImg"
                                  alt="TickImg"
                                />
                              )}
                              <br />
                              {item?.additional_business_status!= null ? item?.additional_business_status: ''}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div ref={contactRef} className="ContactFrmScetion">
          <Container>
            <Row className="align-items-center justify-content-center">
              <Col sm={8}>
                <ContactForm
                  onSubmit={sendInquiry}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default ProductPage;
